import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Alert, Button } from "antd";
import { FC, useEffect, useState } from "react";

import { useSchool } from "../lib/hooks";
import useLocalStorage from "../lib/hooks/useLocalStorage";

import { Loc } from "./Loc";

const SchoolCookieAccepted = "school.cookie.accepted";

export const CookieNotification: FC = () => {
  const school = useSchool();
  const [isVisible, setIsVisible] = useState(false);
  const [isCookieAccepted, setIsCookieAccepted] = useLocalStorage<
    boolean | undefined
  >(SchoolCookieAccepted, false);

  useEffect(() => {
    if (!isCookieAccepted && school.settings.isCookieNotificationEnabled) {
      setIsVisible(true);
    }
  }, [school.settings.isCookieNotificationEnabled, isCookieAccepted]);

  const handleAccept = () => {
    setIsCookieAccepted(true);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="p-10 sticky b-0">
      <Alert
        title={
          <span
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: school.settings.cookieNotificationText!,
            }}
          />
        }
        type="info"
        showIcon
        action={[
          <Button
            key="decline"
            className="mr-10"
            type="default"
            icon={<CloseOutlined />}
            onClick={() => setIsVisible(false)}
          >
            <Loc word="Cookie.decline" default="Decline" />
          </Button>,
          <Button
            key="access"
            type="primary"
            icon={<CheckOutlined />}
            onClick={handleAccept}
          >
            <Loc word="Cookie.accept" default="Approve" />
          </Button>,
        ]}
      />
    </div>
  );
};
